import { Link } from "react-router-dom";
import { featuredProperties } from "../../../mocks/properties";

export default function FeaturedProperties() {
  return (
    <section className="bg-[#EEF2F9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest mb-3 block">
              Underlying Assets
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#071A2E] leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Featured Property Assets
            </h2>
            <p className="text-slate-500 text-sm mt-2 max-w-md">
              UK assisted living and supported housing properties forming the asset base of the Thorpe Dellow Social Housing Structured Product.
            </p>
          </div>
          <Link
            to="/properties"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#071A2E] hover:text-[#C9A84C] transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Assets
            <i className="ri-arrow-right-line leading-none" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {featuredProperties.map((p) => (
            <Link
              key={p.id}
              to={`/properties/${p.id}`}
              className="bg-white rounded-2xl overflow-hidden group cursor-pointer transition-transform hover:-translate-y-1 duration-300 block"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-[#071A2E] text-white text-xs font-semibold px-3 py-1 rounded-full">
                  {p.tag}
                </span>
              </div>
              <div className="p-5">
                <p className="text-xs text-slate-400 font-medium mb-1">{p.type}</p>
                <h3
                  className="font-bold text-[#071A2E] text-base leading-snug mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {p.title}
                </h3>
                <div className="flex items-center gap-1.5 text-slate-400 text-xs mb-3">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line leading-none" />
                  </div>
                  <span>{p.location}</span>
                </div>
                <p className="text-[#C9A84C] font-bold text-sm mb-4">{p.price}</p>
                <div className="border-t border-slate-100 pt-3 flex items-center justify-between text-slate-400 text-xs">
                  <span className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-home-2-line leading-none" />
                    </div>
                    {p.beds} Units
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-layout-line leading-none" />
                    </div>
                    {p.sqft.toLocaleString()} sqft
                  </span>
                  <span className="flex items-center gap-1 text-[#071A2E] font-medium">
                    View
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line leading-none" />
                    </div>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
